<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="Using the Tools"
    [pathBreadcrumbs]="pathBreadcrumbs"
  ></tool-header>

  <tools-support-content class="main-content"></tools-support-content>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getHelpHomepageRelatedLinkBasedOnCard('Using the Tools')
    "
  ></related-links>
</tool-drawer-container>
